

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-multistep-signup-create-account.route', ['squid', 'xo-multistep-signup-create-account.directive']).factory('$MultistepSignupCreateAccountRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MultistepSignupCreateAccountRoute', {
            name: 'multistepsignupcreateaccount',

            directive: 'xo-multistep-signup-create-account',

            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/createAccount/route.js
// module id = ./components/xo-guest-components/src/multistep-signup/createAccount/route.js
// module chunks = 1